import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Icon, IconButton } from "@components/atoms";
import { CachedImage, TextField } from "@components/molecules";
import * as S from "./styles";
import { commonMessages } from "../../../../intl";

var QuantityButtons = function QuantityButtons(add, substract, index) {
  return React.createElement(S.QuantityButtons, null, React.createElement("div", {
    onClick: substract,
    "data-cy": "cartPageItem".concat(index, "QuantityBtnSubtract"),
    role: "button",
    tabIndex: 0
  }, React.createElement(Icon, {
    size: 16,
    name: "horizontal_line"
  })), React.createElement("div", {
    onClick: add,
    "data-cy": "cartPageItem".concat(index, "QuantityBtnAdd"),
    role: "button",
    tabIndex: 0
  }, React.createElement(Icon, {
    size: 16,
    name: "plus"
  })));
};
/**
 * Product row displayed on cart page
 */


export var CartRow = function CartRow(_ref) {
  var index = _ref.index,
      totalPrice = _ref.totalPrice,
      unitPrice = _ref.unitPrice,
      name = _ref.name,
      sku = _ref.sku,
      quantity = _ref.quantity,
      maxQuantity = _ref.maxQuantity,
      onQuantityChange = _ref.onQuantityChange,
      thumbnail = _ref.thumbnail,
      _ref$attributes = _ref.attributes,
      attributes = _ref$attributes === void 0 ? [] : _ref$attributes,
      onRemove = _ref.onRemove;
  var intl = useIntl();

  var _useState = useState(quantity.toString()),
      _useState2 = _slicedToArray(_useState, 2),
      tempQuantity = _useState2[0],
      setTempQuantity = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isTooMuch = _useState4[0],
      setIsTooMuch = _useState4[1];

  var handleBlurQuantityInput = function handleBlurQuantityInput() {
    var newQuantity = parseInt(tempQuantity, 10);

    if (newQuantity <= 0) {
      newQuantity = quantity;
    } else if (newQuantity > maxQuantity) {
      newQuantity = maxQuantity;
    }

    if (quantity !== newQuantity) {
      onQuantityChange(newQuantity);
    }

    var newTempQuantity = newQuantity.toString();

    if (tempQuantity !== newTempQuantity) {
      setTempQuantity(newTempQuantity);
    }

    setIsTooMuch(false);
  };

  useEffect(function () {
    setTempQuantity(quantity.toString());
  }, [quantity]);
  var add = React.useCallback(function () {
    return quantity < maxQuantity && onQuantityChange(quantity + 1);
  }, [quantity]);
  var substract = React.useCallback(function () {
    return quantity > 1 && onQuantityChange(quantity - 1);
  }, [quantity]);

  var handleQuantityChange = function handleQuantityChange(evt) {
    var newQuantity = parseInt(evt.target.value, 10);
    setTempQuantity(evt.target.value);
    setIsTooMuch(newQuantity > maxQuantity);
  };

  var quantityErrors = isTooMuch ? [{
    message: intl.formatMessage(commonMessages.maxQtyIs, {
      maxQuantity: maxQuantity || ""
    })
  }] : undefined;
  return React.createElement(S.Wrapper, null, React.createElement(S.Photo, null, React.createElement(CachedImage, _extends({
    "data-cy": "cartPageItem".concat(index, "Image")
  }, thumbnail))), React.createElement(S.Description, null, React.createElement(S.Name, {
    "data-cy": "cartPageItem".concat(index, "Name")
  }, name), React.createElement(S.Sku, null, React.createElement(S.LightFont, null, intl.formatMessage(commonMessages.sku), ":", React.createElement("span", {
    "data-cy": "cartPageItem".concat(index, "SKU")
  }, sku || "-"))), React.createElement(S.Attributes, {
    "data-cy": "cartPageItem".concat(index, "Attributes")
  }, attributes.map(function (_ref2, attributeIndex) {
    var attribute = _ref2.attribute,
        values = _ref2.values;
    return React.createElement(S.SingleAttribute, {
      key: attribute.id
    }, React.createElement("span", {
      "data-cy": "cartPageItem".concat(index, "SingleAttribute").concat(attributeIndex)
    }, React.createElement(S.LightFont, null, attribute.name, ":"), " ", values.map(function (value) {
      return value.name;
    }).join(", ")));
  }))), React.createElement(S.Quantity, null, React.createElement(TextField, {
    "data-cy": "cartPageItem".concat(index, "QuantityInput"),
    name: "quantity",
    label: intl.formatMessage(commonMessages.quantity),
    value: tempQuantity,
    onBlur: handleBlurQuantityInput,
    onChange: handleQuantityChange,
    contentRight: QuantityButtons(add, substract, index),
    errors: quantityErrors
  })), React.createElement(S.Trash, null, React.createElement(IconButton, {
    "data-cy": "cartPageItem".concat(index, "BtnRemove"),
    size: 22,
    name: "trash",
    onClick: onRemove
  })), React.createElement(S.TotalPrice, null, React.createElement(S.PriceLabel, null, React.createElement(S.LightFont, null, intl.formatMessage(commonMessages.totalPrice), ":")), React.createElement("p", null, totalPrice)), React.createElement(S.UnitPrice, null, React.createElement(S.PriceLabel, null, React.createElement(S.LightFont, null, intl.formatMessage(commonMessages.price), ":")), React.createElement("p", null, unitPrice)));
};